<template>
  <div class="add">
    <form-layout>
      <a-form :model="params" ref="formRef" :rules="rules" @finish="submit">
        <a-form-item label="广告封面" :labelCol="{ span: 4 }" name="cover">
          <a-upload
            class="uploader"
            action="https://api.kanbomusic.com/api/public/upload"
            @change="handleChange"
            :before-upload="beforeUpload"
          >
            <img
              v-if="params.cover"
              :src="params.cover"
              alt="avatar"
              class="avatar"
            />
            <div v-else>
              <loading-outlined v-if="loading"></loading-outlined>
              <!-- <plus-outlined v-else></plus-outlined> -->
              <div class="ant-upload-text">请上传不大于2MB的图片</div>
            </div>
          </a-upload>
          <a-input v-model:value="params.cover" class="hide" />
        </a-form-item>
        <a-form-item
          label="标题"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
          name="title"
        >
          <a-input
            size="large"
            placeholder="请输入标题"
            v-model:value="params.title"
          />
        </a-form-item>
        <a-form-item label="类型" :labelCol="{ span: 4 }" name="type">
          <a-radio-group v-model:value="params.type">
            <a-radio
              v-for="(type, index) in TYPES"
              :key="index"
              :value="type.type"
              >{{ type.label }}</a-radio
            >
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="链接"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
          name="url"
          v-show="params.type == 'VOTE'"
        >
          <a-input
            size="large"
            placeholder="请输入链接"
            v-model:value="params.url"
          />
        </a-form-item>
        <a-form-item
          label="排序"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
        >
          <a-input
            size="large"
            placeholder="请输入排序"
            v-model:value="params.sort"
          />
        </a-form-item>

        <a-form-item
          v-if="params.type != 'VOTE'"
          label="内容"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 20 }"
        >
          <edit @change="editChange" :content="params.content" ref="editRef"></edit>
        </a-form-item>
      </a-form>
    </form-layout>
    <div class="btns">
      <a-button type="primary" size="large" @click="submit">确定</a-button>
      <a-button size="large" @click="cancel">取消</a-button>
    </div>
  </div>
</template>

<script>
import formLayout from "@/layout/form.vue";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { reactive, toRefs, ref, onMounted, watch } from "vue";
import edit from "@/components/edit/index";
import { message } from "ant-design-vue";
import { beforeUpload } from "@/ulit/index";
import { add, getDetails, update } from "@/api/advertising";
import { useRouter, useRoute } from "vue-router";
const TYPES = [
  {
    type: "ARTICLE",
    label: "文章",
  },
  {
    type: "VOTE",
    label: "投票",
  },
];
export default {
  setup() {
    const state = reactive({
      loading: false,
      params: {
        cover: "",
        title: "",
        sort: "",
        content: "",
        status: "2",
        type: "ARTICLE",
        url: "",
      },
    });
    const router = useRouter();
    const route = useRoute();
    const formRef = ref();
    const editRef = ref();
    const rules = {
      cover: [{ required: true, message: "请上传图片", trigger: "blur" }],
      title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      type: [{ required: true, message: "请输入标题", trigger: "change" }],
      url: [{ required: false, message: "请输入跳转链接", trigger: "blur" }],
    };
    watch(
      () => state.params.type,
      (value) => {
        rules.url[0].required = value == "VOTE";
      }
    );
    const handleChange = (info) => {
      if (info.file.status === "uploading") {
        state.loading = true;
        return;
      }
      if (info.file.status === "done") {
        state.params.cover = info.file.response.data.url;
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} 上传失败`);
      }
      state.loading = false;
    };
    const editChange = (html) => {
      state.params.content = html;
    };
    const addHandle = () => {
      add(state.params)
        .then((res) => {
          message.success("新增成功");
          router.push("/advertising");
        })
        .catch(() => {
          message.error("新增失败");
        });
    };
    const updateHandle = () => {
      delete state.params.status;
      update(route.params.id, state.params)
        .then((res) => {
          message.success("修改成功");
          router.push("/advertising");
        })
        .catch(() => {
          message.error("修改失败");
        });
    };
    const submit = () => {
      formRef.value.validate().then((res) => {
        if (route.params.id) {
          updateHandle();
        } else {
          addHandle();
        }
      });
    };
    const init = () => {
      getDetails(route.params.id).then((res) => {
        state.params.cover = res.cover;
        state.params.title = res.title;
        state.params.sort = res.sort;
        state.params.content = res.content;
        state.params.type = res.type ||'ARTICLE';
        state.params.url = res.url;
        editRef.value.initVal(res.content);
      });
    };
    onMounted(() => {
      if (route.params.id) {
        init();
      }
    });
    const cancel = () => {
      router.push("/advertising");
    };
    return {
      PlusOutlined,
      LoadingOutlined,
      formLayout,
      edit,
      ...toRefs(state),
      rules,
      formRef,
      handleChange,
      beforeUpload,
      submit,
      editChange,
      cancel,
      TYPES,
      editRef
    };
  },
};
</script>

<style lang="less">
.add {
  height: 100%;
  .uploader {
    height: 128px;
    width: 128px;
    border: 1px dashed #d9d9d9;
    border-radius: 2px;
    cursor: pointer;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    background-color: #fafafa;
    .ant-upload-list {
      display: none;
    }
  }
  .hide {
    display: none;
  }
  .avatar {
    width: 100%;
    height: 100%;
  }
}
</style>
